import React from 'react'
import ProgressUsage from './ProgressUsage'
import { FolderOpen, Plus } from '@phosphor-icons/react'

const LatestProjects = ({ projects, project_path, projects_path, new_project_path }) => {
  return (
    <div className="card bg-base-100 shadow-2xl border border-base-200 w-full">
      <div className="card-body">
        <div className="flex justify-between items-center">
          <h2 className="card-title">Projects</h2>
          <div className="flex items-start gap-1">
            <a href={projects_path} className="btn btn-sm btn-ghost">
              <div className="flex items-center gap-1">
                <FolderOpen size={16} color="teal"/>
                <span className="text-sm">View All</span>
            </div>
          </a>
          <a href={new_project_path} className="btn btn-sm btn-ghost">
            <div className="flex items-center gap-1">
              <Plus size={16} color="teal"/>
              <span className="text-sm">New Project</span>
            </div>
          </a>
          </div>
        </div>
        <div className="divider"></div>
        {projects.map((project) => (
          <div key={project.id} className="py-2 border-b last:border-b-0">
            <a href={`${project_path.replace(':id', project.id)}`}
               className="link link-hover">{project.name}</a>
          </div>
        ))}
      </div>
    </div>
  )
}

const LatestContents = ({ contents, project_content_path }) => {
  return (
    <div className="card bg-base-100 shadow-2xl border border-base-200 w-full">
      <div className="card-body">
        <h2 className="card-title">Contents</h2>
        
        <div className="divider"></div>
        {contents.map((content) => (
          <div key={content.id} className="py-2 border-b last:border-b-0">
            <a href={`${project_content_path.replace(':id', content.project_id).
              replace(':id', content.id)}`}
               className="link link-hover">{content?.title}</a>
          </div>
        ))}
      </div>
    </div>
  )
}


const LatestResults = ({ latest_results, project_content_path }) => {
  return (
    <div className="card bg-base-100 shadow-2xl border border-base-200 w-full">
      <div className="card-body">
        <h2 className="card-title">Results</h2>
        <div className="divider"></div>
        {latest_results.map((result) => (
          <div key={result?.id} 
               className={`card p-1 border-2 transition-all hover:shadow-md ${
                 result.status === 'pending' ? 'bg-warning' :
                 result.status === 'error' ? 'bg-error' :
                 result.status === 'success' ? 'bg-success' :
                 'bg-base-300'
               }`}>
            <a href={`${project_content_path.replace(':id', result?.project_id).
              replace(':id', result.content_id)}`}
               className="link link-hover">{result?.title}</a>
          </div>
        ))}
      </div>
    </div>
  )
}

const Dashboard = ({
  projects,
  contents,
  total_actions_used,
  max_actions_per_month,
  project_content_path,
  project_path,
  projects_path,
  latest_results,
  new_project_path
}) => {
  return (
    <>
      <div className="flex gap-6 w-full">
        <LatestProjects projects={projects} project_path={project_path}
                        projects_path={projects_path} new_project_path={new_project_path}/>
        <LatestContents contents={contents}
                        project_content_path={project_content_path}/>
                        
        <LatestResults latest_results={latest_results}
                        project_content_path={project_content_path}/>                  
      </div>
      <div className="divider"></div>
      <ProgressUsage max_actions_per_month={max_actions_per_month}
                     total_actions_used={total_actions_used}/>
    </>
  )
}

export default Dashboard
